<template>
    <div class="layout-profile">
        <div>
            <img src="assets/logo.png" alt=""/>
        </div>
        <button class="p-link layout-profile-link" @click="onClick">
            <span class="username">{{$store.state.user.displayName}}</span>
            <i class="pi pi-fw pi-print"></i>
        </button>
        <ExportDialog ref="exportDialog"/>
<!--        <transition name="layout-submenu-wrapper">-->
<!--            <ul v-show="expanded">-->
<!--                <li>-->
<!--                    <button class="p-link"><i class="pi pi-fw pi-user"></i><span>Account</span></button>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <button class="p-link"><i class="pi pi-fw pi-inbox"></i><span>Notifications</span><span-->
<!--                        class="menuitem-badge">2</span></button>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <button class="p-link"><i class="pi pi-fw pi-power-off"></i><span>Logout</span></button>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </transition>-->

    </div>
</template>

<script>
import ExportDialog from "@/components/dialog/ExportDialog";
export default {
    components: {ExportDialog},
    data() {
        return {
            // expanded: false
        }
    },
    methods: {
        onClick(event) {
            // this.expanded = !this.expanded;
            this.$refs.exportDialog.exportDialog = true;
            event.preventDefault();
        }
    }
}
</script>

<style scoped>
</style>